import React from "react";
import Project from "./Project";
import projects from "./data/projects.json";

const Projects = () => {
  const renderContent = () => {
    return projects.map(item => {
      const { project, link, image, description, github } = item;
      return (
        <Project
          key={project}
          name={project}
          link={link}
          image={image}
          description={description}
          github={github}
        />
      );
    });
  };
  return (
    <div style={styles.projContainer} className="container">
      <div style={styles.text}>
        <h1> Projects </h1>
      </div>
      {renderContent()}
    </div>
  );
};

const styles = {
  text: {
    width: "100%",
    textAlign: "center",
    margin: "2rem auto"
  },
  projContainer: {
    margin: "0 auto",
    maxWidth: "1200",
    padding: "0 1rem"
  }
};

export { Projects };
